import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'itl-listitem-bottom-subheader',
  template: '<ng-content></ng-content>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListitemBottomSubheaderComponent {}
